import OutletBookingContext from "pages/OutletPage/outletContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "store";
import { selectOrganization } from "store/selectors";
import { clearCartArticles } from "store/slices/cart/cartSlice";
import { trackEvent } from "tracking";

import HomeServiceConfirmationModal from "./HomeServiceConfirmationModal";

type HomeServiceConfirmUpdateAppointmentModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const HomeServiceConfirmUpdateAppointmentModal = ({
  open,
  onClose,
  onConfirm,
}: HomeServiceConfirmUpdateAppointmentModalProps) => {
  const { t } = useTranslation("outletPage");

  const organization = useSelector(selectOrganization);

  const { setSelectedPurchasable, setSelectedPurchasablePackage } =
    useContext(OutletBookingContext);

  const dispatch = useDispatch();

  const handleProceed = () => {
    dispatch(clearCartArticles());

    setSelectedPurchasable(null);
    setSelectedPurchasablePackage(null);

    if (organization?.id && organization?.name) {
      trackEvent("Lost Cart", { id: organization.id, name: organization.name }, {});

      trackEvent(
        "Cart Initiated",
        { id: organization.id, name: organization.name },
        { isResourceSelected: false }
      );
    }

    onConfirm();
  };

  return (
    <HomeServiceConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={handleProceed}
      description={t("clearCartWarning")}
    />
  );
};
export default HomeServiceConfirmUpdateAppointmentModal;
